// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IRemainderDto } from './IRemainderDto';
import {
    IRemainderDtoFromJSON,
    IRemainderDtoFromJSONTyped,
    IRemainderDtoToJSON,
    IRemainderDtoToJSONTyped,
} from './IRemainderDto';
import type { IChildRecordDto } from './IChildRecordDto';
import {
    IChildRecordDtoFromJSON,
    IChildRecordDtoFromJSONTyped,
    IChildRecordDtoToJSON,
    IChildRecordDtoToJSONTyped,
} from './IChildRecordDto';
import type { ILockboxEntityMatchDto } from './ILockboxEntityMatchDto';
import {
    ILockboxEntityMatchDtoFromJSON,
    ILockboxEntityMatchDtoFromJSONTyped,
    ILockboxEntityMatchDtoToJSON,
    ILockboxEntityMatchDtoToJSONTyped,
} from './ILockboxEntityMatchDto';
import type { ILockboxDtoDetails } from './ILockboxDtoDetails';
import {
    ILockboxDtoDetailsFromJSON,
    ILockboxDtoDetailsFromJSONTyped,
    ILockboxDtoDetailsToJSON,
    ILockboxDtoDetailsToJSONTyped,
} from './ILockboxDtoDetails';
import type { ICheckDetailsDto } from './ICheckDetailsDto';
import {
    ICheckDetailsDtoFromJSON,
    ICheckDetailsDtoFromJSONTyped,
    ICheckDetailsDtoToJSON,
    ICheckDetailsDtoToJSONTyped,
} from './ICheckDetailsDto';
import type { IOcrLockboxDto } from './IOcrLockboxDto';
import {
    IOcrLockboxDtoFromJSON,
    IOcrLockboxDtoFromJSONTyped,
    IOcrLockboxDtoToJSON,
    IOcrLockboxDtoToJSONTyped,
} from './IOcrLockboxDto';
import type { IClaimRepaymentDto } from './IClaimRepaymentDto';
import {
    IClaimRepaymentDtoFromJSON,
    IClaimRepaymentDtoFromJSONTyped,
    IClaimRepaymentDtoToJSON,
    IClaimRepaymentDtoToJSONTyped,
} from './IClaimRepaymentDto';

/**
 * 
 * @export
 * @interface ILockboxDto
 */
export interface ILockboxDto {
    /**
     * 
     * @type {number}
     * @memberof ILockboxDto
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof ILockboxDto
     */
    document_id?: number;
    /**
     * 
     * @type {string}
     * @memberof ILockboxDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ILockboxDto
     */
    form_name?: string;
    /**
     * 
     * @type {string}
     * @memberof ILockboxDto
     */
    lockbox_type?: ILockboxDtoLockboxTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ILockboxDto
     */
    lockbox_status?: ILockboxDtoLockboxStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof ILockboxDto
     */
    archive_type?: ILockboxDtoArchiveTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ILockboxDto
     */
    employee_name?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ILockboxDto
     */
    liquidate_all_funds?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ILockboxDto
     */
    ssn?: string;
    /**
     * 
     * @type {string}
     * @memberof ILockboxDto
     */
    birth_date?: string;
    /**
     * 
     * @type {number}
     * @memberof ILockboxDto
     */
    account_id?: number;
    /**
     * 
     * @type {number}
     * @memberof ILockboxDto
     */
    amount?: number;
    /**
     * 
     * @type {number}
     * @memberof ILockboxDto
     */
    contact_id?: number;
    /**
     * 
     * @type {number}
     * @memberof ILockboxDto
     */
    employee_id?: number;
    /**
     * 
     * @type {string}
     * @memberof ILockboxDto
     */
    account_number?: string;
    /**
     * 
     * @type {ICheckDetailsDto}
     * @memberof ILockboxDto
     */
    check_details?: ICheckDetailsDto;
    /**
     * 
     * @type {string}
     * @memberof ILockboxDto
     */
    request_date?: string;
    /**
     * 
     * @type {Date}
     * @memberof ILockboxDto
     */
    updated_at?: Date;
    /**
     * 
     * @type {Array<ILockboxEntityMatchDto>}
     * @memberof ILockboxDto
     */
    entity_matches?: Array<ILockboxEntityMatchDto>;
    /**
     * 
     * @type {IOcrLockboxDto}
     * @memberof ILockboxDto
     */
    ocr?: IOcrLockboxDto;
    /**
     * 
     * @type {number}
     * @memberof ILockboxDto
     */
    organization_id?: number;
    /**
     * 
     * @type {string}
     * @memberof ILockboxDto
     */
    organization_path?: string;
    /**
     * 
     * @type {number}
     * @memberof ILockboxDto
     */
    invoice_id?: number;
    /**
     * 
     * @type {number}
     * @memberof ILockboxDto
     */
    check_id?: number;
    /**
     * 
     * @type {string}
     * @memberof ILockboxDto
     */
    reason?: ILockboxDtoReasonEnum;
    /**
     * 
     * @type {string}
     * @memberof ILockboxDto
     */
    notes?: string;
    /**
     * 
     * @type {string}
     * @memberof ILockboxDto
     */
    payment_method_type?: ILockboxDtoPaymentMethodTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ILockboxDto
     */
    wire_status_type?: ILockboxDtoWireStatusTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ILockboxDto
     */
    source?: ILockboxDtoSourceEnum;
    /**
     * 
     * @type {boolean}
     * @memberof ILockboxDto
     */
    is_multiple_records?: boolean;
    /**
     * 
     * @type {Array<IChildRecordDto>}
     * @memberof ILockboxDto
     */
    child_records?: Array<IChildRecordDto>;
    /**
     * 
     * @type {number}
     * @memberof ILockboxDto
     */
    parent_id?: number;
    /**
     * 
     * @type {Array<IClaimRepaymentDto>}
     * @memberof ILockboxDto
     */
    claim_repayments?: Array<IClaimRepaymentDto>;
    /**
     * 
     * @type {IRemainderDto}
     * @memberof ILockboxDto
     */
    remainder?: IRemainderDto;
    /**
     * 
     * @type {ILockboxDtoDetails}
     * @memberof ILockboxDto
     */
    details?: ILockboxDtoDetails;
}

/**
* @export
* @enum {string}
*/
export enum ILockboxDtoLockboxTypeEnum {
    UNKNOWN = 'UNKNOWN',
    INBOUND_TOA = 'INBOUND_TOA',
    OUTBOUND_TOA = 'OUTBOUND_TOA',
    RETURNED_CHECK = 'RETURNED_CHECK',
    CLAIM_REPAYMENT = 'CLAIM_REPAYMENT',
    BENEFICIARY = 'BENEFICIARY',
    HSA_FORM = 'HSA_FORM',
    MISTAKEN_DISTRIBUTION = 'MISTAKEN_DISTRIBUTION',
    HSA_ROLLOVER_FORM = 'HSA_ROLLOVER_FORM',
    HSA_CONTRIBUTION_FORM = 'HSA_CONTRIBUTION_FORM',
    HSA_TRANSFER_DIVORCE = 'HSA_TRANSFER_DIVORCE',
    HSA_ACCOUNT_CLOSURE = 'HSA_ACCOUNT_CLOSURE',
    COMBINE_HSA = 'COMBINE_HSA',
    DEATH_DISTRIBUTION = 'DEATH_DISTRIBUTION',
    POWER_OF_ATTORNEY = 'POWER_OF_ATTORNEY',
    RETURNED_MAIL = 'RETURNED_MAIL',
    EXCESS_CONTRIBUTION = 'EXCESS_CONTRIBUTION'
}
/**
* @export
* @enum {string}
*/
export enum ILockboxDtoLockboxStatusEnum {
    NEW = 'NEW',
    PENDING = 'PENDING',
    DECLINED = 'DECLINED',
    APPROVED = 'APPROVED',
    PROCESSING = 'PROCESSING',
    COMPLETED = 'COMPLETED',
    INVESTMENTS_LIQUIDATED = 'INVESTMENTS_LIQUIDATED',
    CANCELED = 'CANCELED',
    DIVIDED = 'DIVIDED',
    PARTIALLY_APPROVED = 'PARTIALLY_APPROVED',
    PROCESSED_MANUALLY = 'PROCESSED_MANUALLY'
}
/**
* @export
* @enum {string}
*/
export enum ILockboxDtoArchiveTypeEnum {
    PAYMENT = 'PAYMENT',
    NOPAYMENT = 'NOPAYMENT'
}
/**
* @export
* @enum {string}
*/
export enum ILockboxDtoReasonEnum {
    CHECK = 'CHECK',
    WIRE = 'WIRE',
    PARTICIPANT_NOT_FOUND = 'PARTICIPANT_NOT_FOUND',
    ACCOUNT_NOT_FOUND = 'ACCOUNT_NOT_FOUND',
    INVESTMENTS_LIQUIDATION_REQUIRED = 'INVESTMENTS_LIQUIDATION_REQUIRED',
    ACCOUNT_CLOSED = 'ACCOUNT_CLOSED',
    INSUFFICIENT_FUNDS = 'INSUFFICIENT_FUNDS',
    OTHER = 'OTHER',
    CLAIM_NOT_FOUND = 'CLAIM_NOT_FOUND'
}
/**
* @export
* @enum {string}
*/
export enum ILockboxDtoPaymentMethodTypeEnum {
    CHECK = 'CHECK',
    WIRE = 'WIRE'
}
/**
* @export
* @enum {string}
*/
export enum ILockboxDtoWireStatusTypeEnum {
    SENT = 'SENT',
    NOT_SENT = 'NOT_SENT'
}
/**
* @export
* @enum {string}
*/
export enum ILockboxDtoSourceEnum {
    UMB = 'UMB',
    DOCUFREE = 'DOCUFREE'
}


/**
 * Check if a given object implements the ILockboxDto interface.
 */
export function instanceOfILockboxDto(value: object): value is ILockboxDto {
    return true;
}

export function ILockboxDtoFromJSON(json: any): ILockboxDto {
    return ILockboxDtoFromJSONTyped(json, false);
}

export function ILockboxDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ILockboxDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'document_id': json['document_id'] == null ? undefined : json['document_id'],
        'name': json['name'] == null ? undefined : json['name'],
        'form_name': json['form_name'] == null ? undefined : json['form_name'],
        'lockbox_type': json['lockbox_type'] == null ? undefined : json['lockbox_type'],
        'lockbox_status': json['lockbox_status'] == null ? undefined : json['lockbox_status'],
        'archive_type': json['archive_type'] == null ? undefined : json['archive_type'],
        'employee_name': json['employee_name'] == null ? undefined : json['employee_name'],
        'liquidate_all_funds': json['liquidate_all_funds'] == null ? undefined : json['liquidate_all_funds'],
        'ssn': json['ssn'] == null ? undefined : json['ssn'],
        'birth_date': json['birth_date'] == null ? undefined : json['birth_date'],
        'account_id': json['account_id'] == null ? undefined : json['account_id'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'contact_id': json['contact_id'] == null ? undefined : json['contact_id'],
        'employee_id': json['employee_id'] == null ? undefined : json['employee_id'],
        'account_number': json['account_number'] == null ? undefined : json['account_number'],
        'check_details': json['check_details'] == null ? undefined : ICheckDetailsDtoFromJSON(json['check_details']),
        'request_date': json['request_date'] == null ? undefined : json['request_date'],
        'updated_at': json['updated_at'] == null ? undefined : (new Date(json['updated_at'])),
        'entity_matches': json['entity_matches'] == null ? undefined : ((json['entity_matches'] as Array<any>).map(ILockboxEntityMatchDtoFromJSON)),
        'ocr': json['ocr'] == null ? undefined : IOcrLockboxDtoFromJSON(json['ocr']),
        'organization_id': json['organization_id'] == null ? undefined : json['organization_id'],
        'organization_path': json['organization_path'] == null ? undefined : json['organization_path'],
        'invoice_id': json['invoice_id'] == null ? undefined : json['invoice_id'],
        'check_id': json['check_id'] == null ? undefined : json['check_id'],
        'reason': json['reason'] == null ? undefined : json['reason'],
        'notes': json['notes'] == null ? undefined : json['notes'],
        'payment_method_type': json['payment_method_type'] == null ? undefined : json['payment_method_type'],
        'wire_status_type': json['wire_status_type'] == null ? undefined : json['wire_status_type'],
        'source': json['source'] == null ? undefined : json['source'],
        'is_multiple_records': json['is_multiple_records'] == null ? undefined : json['is_multiple_records'],
        'child_records': json['child_records'] == null ? undefined : ((json['child_records'] as Array<any>).map(IChildRecordDtoFromJSON)),
        'parent_id': json['parent_id'] == null ? undefined : json['parent_id'],
        'claim_repayments': json['claim_repayments'] == null ? undefined : ((json['claim_repayments'] as Array<any>).map(IClaimRepaymentDtoFromJSON)),
        'remainder': json['remainder'] == null ? undefined : IRemainderDtoFromJSON(json['remainder']),
        'details': json['details'] == null ? undefined : ILockboxDtoDetailsFromJSON(json['details']),
    };
}

export function ILockboxDtoToJSON(json: any): ILockboxDto {
    return ILockboxDtoToJSONTyped(json, false);
}

export function ILockboxDtoToJSONTyped(value?: ILockboxDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'document_id': value['document_id'],
        'name': value['name'],
        'form_name': value['form_name'],
        'lockbox_type': value['lockbox_type'],
        'lockbox_status': value['lockbox_status'],
        'archive_type': value['archive_type'],
        'employee_name': value['employee_name'],
        'liquidate_all_funds': value['liquidate_all_funds'],
        'ssn': value['ssn'],
        'birth_date': value['birth_date'],
        'account_id': value['account_id'],
        'amount': value['amount'],
        'contact_id': value['contact_id'],
        'employee_id': value['employee_id'],
        'account_number': value['account_number'],
        'check_details': ICheckDetailsDtoToJSON(value['check_details']),
        'request_date': value['request_date'],
        'updated_at': value['updated_at'] == null ? undefined : ((value['updated_at']).toISOString()),
        'entity_matches': value['entity_matches'] == null ? undefined : ((value['entity_matches'] as Array<any>).map(ILockboxEntityMatchDtoToJSON)),
        'ocr': IOcrLockboxDtoToJSON(value['ocr']),
        'organization_id': value['organization_id'],
        'organization_path': value['organization_path'],
        'invoice_id': value['invoice_id'],
        'check_id': value['check_id'],
        'reason': value['reason'],
        'notes': value['notes'],
        'payment_method_type': value['payment_method_type'],
        'wire_status_type': value['wire_status_type'],
        'source': value['source'],
        'is_multiple_records': value['is_multiple_records'],
        'child_records': value['child_records'] == null ? undefined : ((value['child_records'] as Array<any>).map(IChildRecordDtoToJSON)),
        'parent_id': value['parent_id'],
        'claim_repayments': value['claim_repayments'] == null ? undefined : ((value['claim_repayments'] as Array<any>).map(IClaimRepaymentDtoToJSON)),
        'remainder': IRemainderDtoToJSON(value['remainder']),
        'details': ILockboxDtoDetailsToJSON(value['details']),
    };
}

